import { render, staticRenderFns } from "./VPSSecurityProfileEmailEdit.vue?vue&type=template&id=935e7422&scoped=true"
import script from "./VPSSecurityProfileEmailEdit.vue?vue&type=script&lang=js"
export * from "./VPSSecurityProfileEmailEdit.vue?vue&type=script&lang=js"
import style0 from "./VPSSecurityProfileEmailEdit.vue?vue&type=style&index=0&id=935e7422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935e7422",
  null
  
)

export default component.exports